// @ts-nocheck

import { useEffect } from "react";
import logo from '../../assets/images/logo.png'
// react-router-dom components
import { useLocation, NavLink } from "react-router-dom";

// prop-types is a library for typechecking of props.
import PropTypes from "prop-types";

// @mui material components
import List from "@mui/material/List";
import Divider from "@mui/material/Divider";
import Link from "@mui/material/Link";
import Icon from "@mui/material/Icon";

// Soft UI Dashboard React components
// @ts-ignore

import SoftBox from "../common/softBox";
// @ts-ignore

import SoftTypography from "../common/softTypography";
// @ts-ignore
import SoftButton from "../common/softButton";

// @ts-ignore
import SidenavCollapse from "./SidenavCollapse";
// @ts-ignore
import SidenavCard from "./SidenavCard";
// @ts-ignore
import SidenavRoot from "./SidenavRoot";
// @ts-ignore
import sidenavLogoLabel from "./styles/sidenav";
import HighlightOffIcon from '@mui/icons-material/HighlightOff';

// @ts-ignore
import { useSoftUIController, setMiniSidenav } from "../../context";
// @ts-ignore
function Sidenav({ color, brand, brandName, routes, ...rest }) {
  // @ts-ignore

  const [controller, dispatch] = useSoftUIController();
  const { miniSidenav, transparentSidenav } = controller;
  const location = useLocation();
  const { pathname } = location;
  const collapseName = pathname.split("/").slice(1)[0];

  const closeSidenav = () => setMiniSidenav(dispatch, true);

  useEffect(() => {
    // A function that sets the mini state of the sidenav.
    function handleMiniSidenav() {
      setMiniSidenav(dispatch, window.innerWidth < 1200);
    }

    /** 
     The event listener that's calling the handleMiniSidenav function when resizing the window.
    */
    window.addEventListener("resize", handleMiniSidenav);

    // Call the handleMiniSidenav function to set the state with the initial value.
    handleMiniSidenav();

    // Remove event listener on cleanup
    return () => window.removeEventListener("resize", handleMiniSidenav);
  }, [dispatch, location]);

  // Render all the routes from the routes.js (All the visible items on the Sidenav)
  // @ts-ignore
  const renderRoutes = routes.map(({ type, name, icon, title, noCollapse, key, route, href }) => {
    let returnValue;

    if (type === "collapse") {
      returnValue = href ? (
        <Link
          href={href}
          key={key}
          target="_blank"
          rel="noreferrer"
          sx={{ textDecoration: "none" }}
        >
          {/* @ts-ignore */}

          <SidenavCollapse
            color={color}
            name={name}
            icon={icon}
            active={key === collapseName}
            noCollapse={noCollapse}
          />
        </Link>
      ) : (
        <NavLink to={route} key={key}>
          {/* @ts-ignore */}

          <SidenavCollapse
            color={color}
            key={key}
            name={name}
            icon={icon}
            active={key === collapseName}
            noCollapse={noCollapse}
          />
        </NavLink>
      );
    } else if (type === "title") {
      returnValue = (
        // @ts-ignore

        <SoftTypography
          key={key}
          display="block"
          variant="caption"
          fontWeight="bold"
          textTransform="uppercase"
          opacity={0.6}
          pl={3}
          mt={2}
          mb={1}
          ml={1}
        >
          {title}
        </SoftTypography>
      );
    } else if (type === "divider") {
      returnValue = <Divider key={key} />;
    }

    return returnValue;
  });

  return (
    // @ts-ignore

    <SidenavRoot {...rest} variant="permanent" ownerState={{ transparentSidenav, miniSidenav }}>
      {/* @ts-ignore */}
      <SoftBox>
        {/* @ts-ignore */}

        <SoftBox
          display={{ xs: "block", xl: "none" }}
          position="absolute"
          top={0}
          right={0}
          p={1.625}
          onClick={closeSidenav}
          sx={{ cursor: "pointer" }}
        >
          {/* @ts-ignore */}

          <SoftTypography variant="h6" color="dark">
            <Icon><HighlightOffIcon /></Icon>
          </SoftTypography>
        </SoftBox>
        {/* @ts-ignore */}

        <SoftBox component={NavLink} to="/" display="flex" alignItems="center">
          {/* @ts-ignore */}

          {/* {brand && <SoftBox component="img" src={brand} alt="Soft UI Logo" width="2rem" />} */}
          {/* @ts-ignore */}

          <SoftBox  textAlign="center"
            width={!brandName && "100%"}
            // @ts-ignore
            sx={(theme) => sidenavLogoLabel(theme, { miniSidenav })}
          >
            {/* @ts-ignore */}

            <SoftTypography textAlign="center" component="h6" variant="button" fontWeight="medium">
              {/* {brandName} */}
              <SoftBox textAlign="center" component="img" src={logo} alt={"title"} borderRadius="lg" />

            </SoftTypography>
          </SoftBox>
        </SoftBox>
      </SoftBox>
      <Divider />
      <List>{renderRoutes}</List>
      {/* @ts-ignore */}

    </SidenavRoot>
  );
}

// Setting default values for the props of Sidenav
Sidenav.defaultProps = {
  color: "final",
  brand: "",
};

// Typechecking props for the Sidenav
Sidenav.propTypes = {
  color: PropTypes.oneOf(["primary", "secondary", "info", "success", "warning", "error", "dark"]),
  brand: PropTypes.string,
  brandName: PropTypes.string.isRequired,
  routes: PropTypes.arrayOf(PropTypes.object).isRequired,
};

export default Sidenav;
